import { get, post } from '../utils/request.js'


export default {
  // 获取新闻列表 
  getnewslist(data) {
    return post('/api/news/newslist', data)
  },
  // 设置阅读公告
  setnews(data) {
    return post('/api/news/setusernew', data)
  },
  // 获取用户信息
  getProfile() {
    return get('/user/profile')
  },
  
  // 更新用户信息
  updateProfile(data) {
    return put('/user/profile', data)
  }
}